import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import ProjectPreview from "../components/ProjectPreview";
import References from "../components/References";

const Home = () => {
  const { t } = useTranslation();
  
  // Animazione per l'h1 del secondo div
  const fullText = ["TURNING", "VISIONS", "INTO", "STRUCTURE"];
  const [visibleWords, setVisibleWords] = useState(0);

  useEffect(() => {
    if (visibleWords < fullText.length) {
      const timer = setTimeout(() => {
        setVisibleWords(visibleWords + 1);
      }, 600); // tempo tra una parola e l'altra
      return () => clearTimeout(timer);
    }
  }, [visibleWords, fullText.length]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar />
      <div 
        className="d-flex flex-column flex-lg-row align-items-center justify-content-center" 
        style={{ 
          minHeight: '80vh', 
          backgroundImage: 'url(https://res.cloudinary.com/dwc20azoo/image/upload/v1758557763/joshua-kettle-VTNJVKTfMq0-unsplash_es4wsu.jpg)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center 30%',
          position: 'relative'
        }}
      >
        {/* Overlay trasparente per migliorare la leggibilità */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(44, 62, 80, 0.18)',
            zIndex: 1
          }}
        ></div>
        
        <div className="container d-flex flex-column align-items-center justify-content-end" style={{ position: 'relative', zIndex: 2, paddingBottom: '12rem' }}>
          <h3 className="hero-quote text-center mb-2" style={{ color: 'white', textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)' }}>
            <span className="quote-mark" style={{ color: 'white' }}>&ldquo;</span>
            {fullText.slice(0, visibleWords).map((word, idx) => (
              <span
                key={idx}
                className="word-fade-in"
                style={{
                  display: "block",
                  transition: "opacity 1.2s cubic-bezier(0.4, 0, 0.2, 1), transform 1.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  transitionDelay: `${idx * 0.15}s`,
                  opacity: 1,
                  transform: "translateY(0)"
                }}
              >
                {word}
                {idx < fullText.length - 1 && <br />}
              </span>
            ))}
            <span className="quote-mark" style={{ color: 'white' }}>&rdquo;</span>
          </h3>
          <Link to="/about-us" className="btn btn-primary">
            {t('home.discoverMore')}
          </Link>
        </div>
      </div>
      {/* Gradiente di transizione */}
      <div style={{
        height: '100px',
        background: 'linear-gradient(to bottom, rgba(44, 62, 80, 0.1), rgba(248, 248, 248, 0.95))',
        marginTop: '-50px',
        position: 'relative',
        zIndex: 1
      }}></div>
      <ProjectPreview />
      <div style={{ marginBottom: '4rem' }}></div>
      <References />
      <Footer />
    </div>
  );
};

export default Home;
